exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".thanks-box{max-width:560px;padding:3rem 2rem}.thanks-icon{display:inline-flex;align-items:center;justify-content:center;width:56px;height:56px;border-radius:50%;background:rgba(94,44,165,.1);margin-bottom:1.5rem}.thanks-icon i{font-size:28px;color:#5e2ca5}.thanks-title{font-size:1.65rem!important;line-height:1.35}.thanks-subtitle{color:#888;font-size:1.1rem!important}@media screen and (max-width:768px){.thanks-box{padding:2rem 1.25rem}.thanks-title{font-size:1.3rem!important}.thanks-subtitle{font-size:1rem!important}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0f9c9fe2","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/lideres/Survey/EndSurvey.vue
// module id = 1060
// module chunks = 2